<template>
  <div class="stock-table">
    <el-table ref="multipleTable" :data="stockTableData" border style="width: 100%" @selection-change="selectOrder">
      <el-table-column type="selection" width="55" fixed="left">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" v-if="showindex">
      </el-table-column>
      <el-table-column prop="self_code" label="商品编码" v-if="templateshow" width="105">
      </el-table-column>
      <el-table-column prop="ruigu_code" width="90" label="锐锢商城编码">
      </el-table-column>
      <el-table-column prop="name" width="330" label="商品名称" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="spec" width="210" label="工厂型号" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="c_name" width="100" label="分类" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="b_name" label="品牌" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="stock_num" width="100" :label="isDeposit ? '当前可用库存' : '库存数量'">
      </el-table-column>

      <el-table-column prop="deposit_count" label="定金购占用库存" width="120" v-if="isDeposit">
      </el-table-column>
      <el-table-column prop="price" width="100" label="供货成交价" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="new_price" width="100" label="待审核价格">
      </el-table-column>
      <el-table-column prop="audit_status" label="价格审核状态" width="100">
        <template slot-scope="scope">
          <div style="text-align: left">
            <span :class="auditStatus(scope.row.audit_status).class"></span>
            <span style="text-align: center; display: inline-block">{{
              auditStatus(scope.row.audit_status).name
              }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商品状态">
        <template slot-scope="scope">
          {{ scope.row.is_enable === "1" ? "启用" : "停用" }}
        </template>
      </el-table-column>

      <el-table-column prop="is_sale" label="是否在售" v-if="templateshow">
      </el-table-column>
      <el-table-column prop="storage_pos" label="库位"> </el-table-column>
      <el-table-column label="最新同步状态">
        <template slot-scope="scope">
          <div v-if="scope.row.sync_time">
            {{ scope.row.sync_status == "1" ? "成功" : "失败" }}
          </div>
          <div v-else></div>
        </template>
      </el-table-column>
      <el-table-column label="最新同步时间" width="140">
        <template slot-scope="scope">
          {{ scope.row.sync_time }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" v-if="showindex" label="操作" width="60">
        <template slot-scope="scope">
          <el-button type="text" style="color: #236bdc" v-if="shopStatus === 1 || shopStatus === -1"
            @click="editGoods(scope.row)">修改</el-button>
          <el-tooltip content="店铺已停用，若需维护，请先启用店铺" placement="bottom" effect="light">
            <el-button type="text" style="color: #236bdc" v-if="shopStatus === -2"><span
                style="color: #999">修改</span></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <stock-dialog ref="stockDialog" v-if="showStockDialog" @updateTable="updateTable" :rowData="rowData"></stock-dialog>
  </div>
</template>
<script>
import stockDialog from "@/components/stock/stock-dialog.vue";
export default {
  components: { stockDialog },
  props: ["stockTableData", "showindex", "templateshow"],
  data() {
    return {
      orderTableData: [],
      showStockDialog: false,
      selectLength: 0,
      rowData: {},
      shopStatus: "",
      isDeposit: localStorage.getItem("is_deposit")
    };
  },
  mounted() {
    let enable = localStorage.getItem("is_enable");
    let status = localStorage.getItem("close_status");
    if (enable == "1") {
      this.shopStatus = 1;
    } else {
      if (status == "1") {
        this.shopStatus = -1;
      }
      if (status == "2") {
        this.shopStatus = -2;
      }
    }
  },

  methods: {
    editGoods(row) {
      this.rowData = row;
      // scope.row.id,scope.row.new_price,scope.row.price,scope.row.stock_num
      this.showStockDialog = true;
      this.$nextTick(() => {
        this.$refs.stockDialog.stockDialogVisable = true;
        this.$refs.stockDialog.is_deposit = row.is_deposit;
        this.$refs.stockDialog.stockDialogForm.id = row.id;
        this.$refs.stockDialog.stockDialogForm.new_price = row.new_price;
        this.$refs.stockDialog.stockDialogForm.price = row.price;
        this.$refs.stockDialog.stockDialogForm.change_stock_num = row.stock_num;
        this.$refs.stockDialog.stockDialogForm.ruigu_code = row.ruigu_code;
      });
    },
    updateTable() {
      this.$emit("updateTable");
      this.showStockDialog = false;
    },
    selectOrder(val) {
      const { shop_id: shopId = "", ruigu_code: ruiguCode = "" } = val.length
        ? val[0]
        : {};

      if (val.length > 1) {
        this.$message.warning("只能勾选一个");
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(val[0]);
      } else {
        this.$emit(
          "handleShowAddStoragePos",
          val.length === 1,
          shopId,
          ruiguCode
        );
      }
    },
    auditStatus(val) {
      let obj = {
        name: "",
        class: ""
      };
      switch (val) {
        case "1":
          obj.name = "待审核";
          obj.class = "status waiting-status";
          break;
        case "2":
          obj.name = "审核通过";
          obj.class = "status success-status";
          break;
        case "-1":
          obj.name = "审核不通过";
          obj.class = "status nopass-status";
          break;

        default:
          break;
      }
      return obj;
    }
  }
};
</script>
<style lang="scss" scoped>
.stock-table {
  border-top: 1px dashed #999;

  // padding-top: 20px;
  .el-input__inner {
    max-width: 240px;
  }
}

.status {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-left: 5px;
}

.success-status {
  background-color: #3dca21;
}

.waiting-status {
  background-color: #fdc43b;
}

.nopass-status {
  background-color: #ff4545;
}
</style>



// WEBPACK FOOTER //
// src/components/stock/stock-table.vue